module.exports = __webpack_public_path__ + "static/media/classShedule_menu_icon.eaeb03fd.svg";